import { css } from '@emotion/core';
import { rgba, tokens, globalTokens } from '@domain-group/fe-brary';
var thumbnailsHeight = '120px';
var modalControlsHeight = '48px';
var navButtonsWidth = '100px';
var colors = tokens.colors;
export var carouselItem = _ref => {
  var innerHeight = _ref.innerHeight;
  return /*#__PURE__*/css("position:relative;width:100%;height:", innerHeight, "px;margin-top:calc(100vh - ", innerHeight, "px);");
};
export var interactive = _ref2 => {
  var layout = _ref2.layout;
  return /*#__PURE__*/css("position:absolute;top:", modalControlsHeight, ";bottom:", layout.thumbnails ? thumbnailsHeight : modalControlsHeight, ";left:", layout.navButtons ? navButtonsWidth : modalControlsHeight, ";right:", layout.navButtons ? navButtonsWidth : modalControlsHeight, ";");
};
export var image = {
  name: "wasaoq",
  styles: "width:100%;height:100%;background-repeat:no-repeat;background-size:contain;background-position:center;"
};
export var overlay = /*#__PURE__*/css("position:absolute;top:0;left:0;bottom:0;border:0;outline:none;width:100%;height:100%;background-color:", rgba(globalTokens.colors.black, 0.7), ";");
export var clickable = /*#__PURE__*/css("background-color:", rgba(globalTokens.colors.black, 0.8), ";");
export var overlayIcon = /*#__PURE__*/css("width:48px;height:48px;color:", colors.neutral.subdued.default, ";");
export var virtualTourIFrame = {
  name: "uwwqev",
  styles: "width:100%;height:100%;"
};
export var asLink = {
  name: "4g6ai3",
  styles: "cursor:pointer;"
};